import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '@/stores/auth'
import MainLayout from '@/layouts/MainLayout.vue'
import AuthLayout from '@/layouts/AuthLayout.vue'

const routes = [
  {
    path: '/auth',
    component: AuthLayout,
    children: [
      {
        path: 'login',
        name: 'Login',
        component: () => import('@/views/auth/Login.vue')
      }
    ]
  },
  {
    path: '/',
    component: MainLayout,
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        name: 'Dashboard',
        component: () => import('@/views/Dashboard.vue')
      },
      {
        path: 'brands',
        name: 'Brands',
        component: () => import('@/views/brands/BrandList.vue')
      },
      {
        path: 'brands/create',
        name: 'BrandCreate',
        component: () => import('@/views/brands/BrandForm.vue')
      },
      {
        path: 'brands/:id/edit',
        name: 'BrandEdit',
        component: () => import('@/views/brands/BrandForm.vue')
      },
      {
        path: 'products',
        name: 'Products',
        component: () => import('@/views/products/ProductList.vue')
      },
      {
        path: 'products/:id',
        name: 'ProductDetail',
        component: () => import('@/views/products/ProductDetail.vue')
      },
      {
        path: 'categories',
        name: 'Categories',
        component: () => import('@/views/categories/CategoryList.vue')
      },
      {
        path: 'jobs',
        name: 'Jobs',
        component: () => import('@/views/jobs/JobList.vue')
      },
      {
        path: 'export-files',
        name: 'ExportFiles',
        component: () => import('@/views/export/ExportFileList.vue')
      },
      {
        path: 'api-schedule',
        name: 'ApiSchedule',
        component: () => import('@/views/export/ApiScheduleList.vue')
      },
      {
        path: 'templates',
        name: 'Templates',
        component: () => import('@/views/templates/TemplateList.vue')
      },
      {
        path: 'templates/create',
        name: 'TemplateCreate',
        component: () => import('@/views/templates/TemplateEditor.vue')
      },
      {
        path: 'templates/:id/edit',
        name: 'TemplateEdit',
        component: () => import('@/views/templates/TemplateEditor.vue')
      },
      {
        path: 'api-logs',
        name: 'ApiLogs',
        component: () => import('@/views/logs/ApiLogList.vue')
      },
      {
        path: 'api-endpoints',
        name: 'ApiEndpoints',
        component: () => import('@/views/api-endpoints/ApiEndpointList.vue')
      },
      {
        path: 'system-health',
        name: 'SystemHealth',
        component: () => import('@/views/system/SystemHealth.vue')
      },
      {
        path: 'cost-analysis',
        name: 'CostAnalysis',
        component: () => import('@/views/analytics/CostAnalysis.vue')
      },
      {
        path: 'data-sources',
        name: 'DataSources',
        component: () => import('@/views/data-sources/DataSourceList.vue')
      },
      {
        path: 'platform-definitions',
        name: 'PlatformDefinitions',
        component: () => import('@/views/platforms/PlatformList.vue')
      }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// Navigation guard
router.beforeEach((to, from, next) => {
  const authStore = useAuthStore()
  
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!authStore.isAuthenticated) {
      next({ name: 'Login' })
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router

